export interface IThemesState {
  current: IThemes;
  list: Array<IThemes>;
}

export interface IThemes {
  id: any;
  name?: {
    it?: string;
    sl?: string;
    en?: string;
  };
}

export const THEMES_STATE = {
  current: null,
  list: []
};

export class Themes implements IThemes {
  id: any;
  name?: {
    it?: string;
    sl?: string;
    en?: string;
  };

    constructor(obj: IThemes = {} as IThemes) {
        const {
          id= null,
          name= {},
        } = obj;

        this.id = id,
        this.name = name;
    }

    static from(obj): IThemes {
      return new Themes({
        id : obj.idthematic,
        name : {
          it : obj.name_it,
          sl : obj.name_sl,
          en : obj.name_en
        }
      });
  }
  static fromArray(list) {
    if (!list || !(list instanceof Array)) {
        return [];
    }
    return list.map((obj) => Themes.from(obj));
  }

  static to(obj) {
    return {
      idthematic : obj.id,
      name_it : obj.name.it,
      name_sl : obj.name.sl,
      name_en : obj.name.en
    };
  }
  static toArray(list) {
    if (!list || !(list instanceof Array)) {
        return [];
    }
    return list.map(Themes.to).filter(item => item != null);
  }
}
